import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { PropTypes, string } from 'prop-types';
import { Avatar } from '@material-ui/core';
import UndoRoundedIcon from '@material-ui/icons/UndoRounded';
import logo from '../images/logo-3.png';
import { storeContext } from '../components/provider/Provider';
import { websiteSwitchActions } from '../store/website-switch-reducer';
import { websiteAnalyticsActions } from '../store/website-analytics-reducer';
import { leadsActions } from '../store/leads-reducer';
import { contentActions } from '../store/content-reducer';
import { authActions } from '../store/auth-reducer';

const useStyles = makeStyles(() => ({
  inner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    marginRight: '10%',
  },
  titleBackIcon: {
    fontSize: '1.5rem',
    transform: 'rotate(40deg)',
    position: 'absolute',
    left: '5%',
    top: '2.5%',
    zIndex: 5,
    opacity: 1,
    transition: 'opacity 0.5s',
    '&.navOpen': {
      position: 'fixed',
    },
    '&.removed': {
      opacity: 0,
    },
  },
  outter: {
    width: '100%',
    padding: '40px 0',
    position: 'relative',
    background: 'none',
    zIndex: 1,
    '&.openedNav': {
      position: 'fixed',
      background: '#f5f6f8',
      zIndex: 3,
      height: 0,
      padding: 0,
      transition: 'height 0.5s, padding 0.5s',
      '&>div': {
        opacity: 0,
        transition: 'opacity 0.25s',
      },
    },
  },
  topNav: {
    position: 'absolute',
    top: 0,
    padding: '40px 0',
    background: '#f5f6f8',
    transform: 'translate(0, -100%)',
    transition: 'transform 0.5s, box-shadow 0.5s',
    width: '100%',
    zIndex: 4,
    boxShadow: 'none',
    '&.navOpen': {
      position: 'fixed',
    },
    '& *:not(.MuiSvgIcon-root)': {
      opacity: 0,
      transition: 'opacity 0.25s',
    },
    '&.open': {
      transform: 'translate(0, 0)',
      boxShadow: '0px 7px 5px 0px rgba(0,0,0,0.05)',
      '& *': {
        opacity: 1,
      },
    },
  },
  topNavLinks: {
    display: 'block',
    textAlign: 'center',
  },
  topNavLink: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    color: '#C2CFE0',
    width: '50%',
    fontSize: '1.35rem',
    '& .MuiSvgIcon-root': {
      marginRight: '10%',
    },
    '& p': {
      color: 'black',
      textAlign: 'left',
    },
  },
}));

const MobileTitle = ({ title, children }) => {
  const [imageNotFound, setImageNotFound] = useState(false);
  const [avatarCopy, setAvatarCopy] = useState('HD');
  const classes = useStyles();
  const { state, dispatch } = React.useContext(storeContext);
  const history = useHistory();
  const [, , removeCookie] = useCookies(['websiteSwitch']);

  const onError = () => setImageNotFound(true);

  const onLoad = () => setImageNotFound(false);

  useEffect(() => {
    if (state.websiteSwitch.currentWebsite === null)
      return;

    setAvatarCopy(state.websiteSwitch.currentWebsite.substring(0, 2).toUpperCase());
  }, [state.websiteSwitch.currentWebsite]);

  const handleTopNav = () => {
    document.getElementById('mobileTopNav').classList.toggle('open');
  };

  const switchWebsite = () => {
    dispatch({ type: websiteSwitchActions.CLEAN_WEBSITE_CHOSEN });
    dispatch({ type: websiteAnalyticsActions.WEBSITE_ANALYTICS_CLEAN });
    dispatch({ type: leadsActions.LEADS_CLEAN });
    dispatch({ type: contentActions.CONTENT_CLEAN });
    removeCookie('websiteSwitch');
    history.push('/switch-website');
  };

  const handleLogout = () => {
    dispatch({ type: authActions.LOGOUT });
    dispatch({ type: websiteSwitchActions.CLEAN_WEBSITE_SWITCH });
    dispatch({ type: websiteAnalyticsActions.WEBSITE_ANALYTICS_CLEAN });
    dispatch({ type: leadsActions.LEADS_CLEAN });
    dispatch({ type: contentActions.CONTENT_CLEAN });
    history.push('/login');
  };

  return (
    <>
      <UndoRoundedIcon className={classes.titleBackIcon} onClick={handleTopNav} id="topNavButton" />
      <div className={classes.topNav} id="mobileTopNav">
        <div className={classes.topNavLinks}>
          <center>
            <div
              aria-hidden="true"
              aria-label="Top Nav Button 1"
              className={classes.topNavLink}
              onClick={switchWebsite}
            >
              <FilterNoneIcon />
              <p>Switch Website</p>
            </div>
            <div
              aria-hidden="true"
              aria-label="Top Nav Button 2"
              className={classes.topNavLink}
              onClick={handleLogout}
            >
              <ExitToAppIcon />
              <p>Logout</p>
            </div>
          </center>
        </div>
      </div>
      <div className={classes.outter} id="mobileTitle">
        <div className={classes.inner}>
          {imageNotFound === false ?
            <Avatar style={{ width: 40, height: 40, marginRight: 16 }}>
              <img
                src={
                  state.websiteSwitch.currentWebsite
                    ? `https://hd-platform-icons.s3.us-west-1.amazonaws.com/Profile+Images/${state.websiteSwitch.currentWebsite}.png`
                    : logo
                }
                onError={onError}
                onLoad={onLoad}
                alt="logo3"
              />
            </Avatar> :
            <Avatar style={{ width: 40, height: 40, marginRight: 16 }}>{avatarCopy}</Avatar>
          }
          <div style={{ fontSize: 30 }}>{title}</div>
          {children}
        </div>
      </div>
    </>
  );
};

MobileTitle.propTypes = {
  title: string.isRequired,
  children: PropTypes.node,
};

MobileTitle.defaultProps = {
  children: null,
};

export default MobileTitle;
